import { useEffect } from "react";
import { createPortal } from "react-dom";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

export const Lightbox = ({ open, src, caption, onClose }) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  return createPortal(
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="lightbox"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          className="fixed inset-0 z-[100] bg-black/92 backdrop-blur-sm flex items-center justify-center p-4 md:p-10 cursor-zoom-out"
        >
          <button
            data-testid="lightbox-close"
            onClick={onClose}
            aria-label="Cerrar"
            className="fixed top-5 right-5 z-[110] h-12 w-12 rounded-full bg-white/15 hover:bg-white/30 flex items-center justify-center text-white transition"
          >
            <X size={24} />
          </button>
          <motion.figure
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
            onClick={onClose}
            className="flex flex-col items-center max-w-5xl w-full"
          >
            <img src={src} alt={caption || ""} className="max-h-[82vh] w-auto rounded-2xl object-contain shadow-2xl" />
            {caption && <figcaption className="font-accent text-2xl md:text-3xl text-[#A8E010] mt-4 text-center">{caption}</figcaption>}
          </motion.figure>
        </motion.div>
      )}
    </AnimatePresence>,
    document.body
  );
};
